export const newsEditComponent = {
  template: `
    <news-main
      type="edit"
      tags=$ctrl.tags
      details=$ctrl.details
      categories=$ctrl.categories
      title="edit news article">
    </news-main>
  `,
  bindings: {
    details: "<",
    tags: "<",
    categories: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/components/news/news-edit/news-edit.component.js